import {HttpErrorResponse} from '@angular/common/http';
import {BrowserAuthError, InteractionRequiredAuthError} from '@azure/msal-browser';

const BACKEND_UNAVAILABLE_STATUSES = new Set([0, 502, 503, 504]);

const readStatus = (error: unknown): number | null => {
  if (error instanceof HttpErrorResponse) {
    return typeof error.status === 'number' ? error.status : null;
  }

  if (error && typeof error === 'object' && typeof (error as {status?: unknown}).status === 'number') {
    return (error as {status: number}).status;
  }

  return null;
};

const isInteractiveAuthFailure = (error: unknown): boolean =>
  error instanceof InteractionRequiredAuthError || error instanceof BrowserAuthError;

export const shouldMarkBetaBackendUnavailable = (error: unknown, runtimeEnvironment: string): boolean => {
  if (runtimeEnvironment !== 'beta') {
    return false;
  }

  if (isInteractiveAuthFailure(error)) {
    return false;
  }

  const status = readStatus(error);
  return status !== null && BACKEND_UNAVAILABLE_STATUSES.has(status);
};
